export const emailValidation = (value) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!value || regex.test(value) === false) {
        return 'Email is not valid'
    }
}

export const checkString = (value) => {
    const checkStringValue = (/\d/.test(value));
    if (checkStringValue) {
        return 'This value is not valid.'
    }
}

export const checkPassword = (value) => {
    if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(value)) {
        return 'Password will be 8 character long. Password must have at least one uppercase letter, one lowercase letter, one number and one special character'
    }
}

export const comparePassword = (value, stringToCompare) => {
    if (value !== stringToCompare) {
        return 'Password and Confirm Password does not match.'
    }
}

export const checkBlankSpace = (stringVal) => {
    if (/\s/g.test(stringVal)) {
        return 'White space is not allowed'
    }
};

export const checkNumber = (value, fieldname) => {
      if (value === "" || value === null || value === undefined) {
    return "";
  }
  const re = /^[+-]?\d+(?:\.\d*(?:[eE][+-]?\d+)?)?$/;
  if (!re.test(value)) {
    return "This value is not valid. Only numbers are allowed.";
  }
  return "";
}

export const checkPositiveNumber = (value, fieldname) => {
    const re = /^\d*[.]?\d*$/;
    if (!re.test(value)) {
        return 'This value is not valid. Only Positive numbers are allowed.'
    }
}

export const checkSpecialChar = (value, fieldname) => {
    const re = /[~!@#$%^&*)(+:[}\]{="`]/;
    if (re.test(value)) {
        return 'This value is not valid.'
    }
}
export const checkSlashes = (value, fieldname ) => {
    const hasForwardSlash = value.includes('/');
    const hasBackwardSlash = value.includes('\\');

    if (hasForwardSlash && hasBackwardSlash) {
        return `${fieldname} must not contain '/' or '\\'.`;
    } else if (hasForwardSlash) {
        return `${fieldname} must not contain '/'.`;
    } else if (hasBackwardSlash) {
        return `${fieldname} must not contain '\\'.`;
    }
    
    return null; 
};
export const checkShortKey = (value, fieldname) => {
    const re = /[A-Z]{2,}/;
    if (!re.test(value)) {
        return 'This value is not valid.Only 2 capital Characters are allowed.'
    }
}

export const isUrlValid = (userInput) => {
    var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    if (res === null) {
        return 'This url is not valid.'
    }
}

export const checkAccountNumber = (number) => {
    const accountNo = number.match(/^[0-9]{9,18}$/);
    if (!accountNo) {
        return "Account number is not valid"
    }
}

export const checkPhoneNumber = (number) => {
    const phoneNo = number.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/);
    if (!phoneNo) {
        return "Phone number is not valid"
    }
}
export const checkFaxNumber = (number) => {
    const phoneNo = number.match(/^(\+?\d{1,}(\s?|\-?)\d*(\s?|\-?)\(?\d{2,}\)?(\s?|\-?)\d{3,}\s?\d{3,})$/gm);
    if (!phoneNo) {
        return "Fax number is not valid"
    }
}

export const checkIBAN = (number) => {
    const newno = number.split(" ").join("");
    const iban = newno.match(/^([A-Z]{2}[ '+'\\'+'-]?[0-9]{2})(?=(?:[ '+'\\'+'-]?[A-Z0-9]){9,30}$)((?:[ '+'\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\'+'-]?[A-Z0-9]{1,3})?$/);
    if (!iban) {
        return "IBAN is not valid"
    }
}

export const checkABNumber = (number) => {
 const abNumber = number.match(/^\d{7}\s(\-{2}|\d{2})$/)
 if(!abNumber){
    return "AB Number is not valid"
 }
}
